module.exports = __webpack_public_path__ + "img/police_station.754a86ee.png";